
/**
 * Generates Firebase Storage URL for checklist images
 * @param {string} sport - Sport name
 * @param {string} year - Year
 * @param {string} manufacturer - Manufacturer name
 * @param {string} seriesName - Series name
 * @returns {string} Firebase Storage URL
 */
export const getChecklistImageUrl = (sport, year, manufacturer, seriesName) => {
  // Sanitize the series name for safe filename usage
  const sanitizeTitle = (title) => {
    return title
      .replace(/[^a-zA-Z0-9 _-]/g, "")  // remove special characters
      .replace(/\s+/g, "_")             // replace spaces with underscores
      .toLowerCase();                   // make lowercase
  };
  
  const sanitizedSeriesName = sanitizeTitle(seriesName);
  
  // Construct the Firebase Storage URL
  // Format: https://firebasestorage.googleapis.com/v0/b/{bucket}/o/{path}?alt=media
  const bucket = 'pull-vault-dev.firebasestorage.app'; // Correct bucket name
  
  // Use uppercase for sport and manufacturer to match Firebase Storage structure
  const path = `checklist-images/${sport.toUpperCase()}/${year}/${manufacturer}/${sanitizedSeriesName}.png`;
  
  
  // Encode the path for URL
  const encodedPath = encodeURIComponent(path);
  
  const finalUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodedPath}?alt=media`;
  
  return finalUrl;
};

/**
 * Generates a generic Firebase Storage URL
 * @param {string} path - Storage path
 * @param {string} bucket - Storage bucket name
 * @returns {string} Firebase Storage URL
 */
export const getStorageUrl = (path, bucket = 'pull-vault-dev.firebasestorage.app') => {
  const encodedPath = encodeURIComponent(path);
  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodedPath}?alt=media`;
};
